import Component from '../Component';
import Routes from '../../routes';

export default class Airport extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    return super.initialize();
  }

  search(query, country, callback) {

    return this.App.API.get(Routes.API.CONTENT.GEO.AIRPORTS, {
      query:   query,
      country: country
    }).then((response) => {

      if (response.data) {

        if (typeof response.data.data != 'undefined' && response.data.data.length > 0) {
          return callback(response.data.data);
        }

        return callback([]);

      }

      callback([]);

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    }).catch((error) => {

      callback([]);

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    });

  }
}